import React, { useMemo } from "react";
import cx from "components/src/utils/cx";
import { cssColor } from "shared/src/utils/cssUtils";
import { sizeStyles } from "shared/src/styles/sizeStyles";
import { AvatarSlotProps } from "../types";
import { calcDivideBy } from "shared/src/utils/mathUtils";

export const AvatarSlot = ({
  children,
  align,
  sizeMap,
  showBorder = true,
  shape = "circle",
  bg = "cui-bg-neutrals-transparent",
  size,
  forceEdgeAlignment = false,
}: AvatarSlotProps) => {
  console.log({ size });
  const isPaddedCircle = showBorder && shape === "circle";

  const { sizeMap: _sizeMap } = useMemo(() => {
    if (typeof size !== "undefined" && size !== null) {
      return sizeStyles(size);
    }
    return { sizeMap };
  }, [size, sizeMap]);

  const _style = useMemo(() => {
    const width = calcDivideBy(_sizeMap?.width, 3);
    const height = calcDivideBy(_sizeMap?.height, 3);

    const isZero = isPaddedCircle || forceEdgeAlignment;

    const pos =
      align === "left"
        ? { left: isZero ? 0 : calcDivideBy(width, 3) }
        : { right: isZero ? 0 : calcDivideBy(height, 3) };

    return {
      width,
      height,
      background: cssColor(bg),
      ...pos,
      bottom: isZero ? 0 : calcDivideBy(height, 3),
      // transform: `translateX(${xOffset}) translateY(${yOffset})`
    };
  }, [_sizeMap, forceEdgeAlignment]);

  return (
    <div
      className={cx(
        {
          "cui-border cui-border-solid cui-border-1 cui-border-fg-subtle":
            showBorder,
          "cui-rounded-[9999px]": shape === "circle",
        },
        "cui-absolute cui-flex cui-items-center cui-justify-center cui-z-20"
      )}
      style={_style}
    >
      {children}
    </div>
  );
};
